import axios from "axios";

const getInstance = async (country, file, skipauth) => {
    const baseURL = `https://grupoaldiapi.expresatebox.io/${country || "admin"}/rest`;
    // const baseURL = `http://localhost:7700/${country || "admin"}/rest`;
    // const baseURL = `https://${
    //   process.env.NODE_ENV === "production" ? "bose" : "devapi"
    // }.grupoaldi.com/${country || "admin"}/rest`;
  let heads = {
    "Content-Type": file ? "multipart/form-data" : "application/json",
  };

  if(typeof skipauth === "undefined") {
    const auth = localStorage.getItem("admin_ath");
    if (auth !== null) {
      heads["Authorization"] = "Bearer " + auth;
    } 
  }

  const timeout = 60000;
  const request = axios.create({
    baseURL,
    timeout,
    headers: heads,
  });

  // Interceptor para manejar expiración de token
  request.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        // Mostrar alerta
        window.alert('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
        // Limpiar localStorage
        localStorage.removeItem('aldi_dash');
        localStorage.removeItem('admin_ath');
        // Redirigir al login
        window.location.href = '/';
      }
      return Promise.reject(error);
    }
  );
  /* request.interceptors.request.use(
    async config => {
      const token = localStorage.getItem('delos_user');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    error => Promise.reject(error)
  ) */
  return request;
};

export default getInstance;
